import React, {Component} from "react"
import {HashRouter as Router, Redirect, Route} from "react-router-dom"
import {Dimmer, Header, Image, Loader, Segment} from "semantic-ui-react"
//import { useTranslation, Trans } from "react-i18next";

import "./App.css"
import api from "./api"
import history from "./history"
// PAGES
import AcceptPage from "./pages/AcceptPage"
import TasksPage from "./pages/TasksPage"
import TaskPage from "./pages/TaskPage"
import DocumentsPage from "./pages/DocumentsPage"
import EscalatePage from "./pages/EscalatePage"
import SummaryPage from "./pages/SummaryPage"
import SubmitPage from "./pages/SubmitPage"
import SignPage from "./pages/SignPage"
import HomePage from "./pages/HomePage"

import logoSrc from "./icon_mfr.png"

class App extends Component {
  constructor() {
    super()
    this.state = {
      loaded: false, error: false, showLoader: false
    }

    api.injectHistory(history)
    history.listen(function (location) {
      try {
        window.ga('send', 'pageview', location.hash.substr(1))
      } catch (e) {
        console.warn(e)
      }
    })

    api.loadOrder()
      .then(() => {
        this.setState({
          loaded: true
        })
      }).catch(e => {
      console.warn("error", e)
    })

    setTimeout(() => {
      if (!this.state.loaded) {
        this.setState({
          showLoader: true
        })
      }
    }, 1200)

  }

  getInitialState(stateCode) {
    switch (true) {
      case this.error === true:
        return <Redirect from="*" to="/error"/>
      case stateCode === "eCustomError":
        return <Redirect from="*" to="/error"/>
      case stateCode === "eRejected":
        return <Redirect from='*' to='/'/>
      case stateCode === "eSubcontractorRejected":
        return <Redirect from='*' to='/accept/new'/>
      case stateCode === "eClosed":
        return <Redirect from='*' to='/summary'/>
      case stateCode === "eSubcontractorPendingConfirmation":
        return <Redirect from='*' to='/accept/new'/>
      case stateCode === "eSubcontractorConfirmed":
        return <Redirect from='*' to='/accept/accepted'/>
      case stateCode === "eIsWorkDone":
        return <Redirect from='*' to='/summary'/>
      default:
        return <Redirect from="*" to="/404"/>
    }
  }

  componentDidMount() {
    this.historyUnlisten = history.listen(() => this.scrollToTop())
  }

  componentWillUnmount() {
    this.historyUnlisten()
  }

  scrollToTop() {
    window.scrollTo(0, 0)
  }

  render() {
    let {loaded, showLoader} = this.state

    //const { t, i18n } = useTranslation();

    //i18n.changeLanguage();

    if (api.error) {
      return (
        <Dimmer
          active={true}
          page
        >
          <div className="tc">Fehler bei der Auftragsverarbeitung.</div>
        </Dimmer>
      )
    }

    if (!api.token) {
      return (
        <Dimmer
          active={true}
          page>
          <Image className="slide-in" width="75" src={logoSrc} style={{marginTop: "-120px"}} centered/>
          Kein gültiger Auftragslink. Den Auftragslink finden Sie in Ihrer Auftrags-E-Mail.
        </Dimmer>
      )
    }

    if (!loaded && showLoader) {
      return <PleaseWait/>
    }

    if (!loaded) {
      return null
    }

    let order = api.getOrder()
    return (
      <Router history={history}>
         <div className="wrapper">
           {this.getInitialState(order.StateCode)}
           <Route render={({location}) => (
             <div>
               <Route
                 location={location}
                 exact
                 path="/"
                 component={HomePage}/>

               <Route
                 path="/accept"
                 component={AcceptPage}/>

               <Route
                 exact
                 path="/tasks"
                 component={TasksPage}/>

               <Route
                 exact
                 path={`/tasks/:step_id`}
                 component={TaskPage}/>

               <Route
                 exact
                 location={location}
                 path="/escalate"
                 component={EscalatePage}/>

               {/*<Route*/}
               {/*exact*/}
               {/*location={location}*/}
               {/*path="/invoice"*/}
               {/*component={InvoicePage}/>*/}

               <Route
                 exact
                 location={location}
                 path="/summary"
                 component={SummaryPage}/>

               <Route
                 exact
                 location={location}
                 path="/documents"
                 component={DocumentsPage}/>

               <Route
                 exact
                 location={location}
                 path="/sign"
                 component={SignPage}/>

               <Route
                 exact
                 location={location}
                 path="/submit"
                 component={SubmitPage}/>


               <Route
                 exact
                 location={location}
                 path="/error"
                 component={ErrorPage}/>

               <Route
                 exact
                 location={location}
                 path="/404"
                 component={NotFoundPage}/>


             </div>
           )}/>
         </div>
      </Router>
    )
  }
}

//
// const AnimatedRoute = ({children}) => {
//   if (children) {
//     return (
//       <CSSTransitionGroup
//         transitionName="fade"
//         transitionLeaveTimeout={1000}
//         transitionEnterTimeout={1000}
//         transitionAppearTimeout={1000}
//       >
//         {children}
//       </CSSTransitionGroup>
//     )
//   }
//   return null
// }


const NotFoundPage = () => (  <Dimmer
  active={true}
  page
>
  <div className="f2">404</div>
  <div className="tc">Auftragsdaten nicht gefunden</div>
</Dimmer>)

const ErrorPage = () => {
  return (
   <div className="mt4">
     <Segment >
       <div className="pt5 pb5 bg-white tc">
         <Header as="h1">Fehler bei der Datenverarbeitung</Header>
         <p className="pt3 pb4">Beim Verarbeiten Ihrer Anfrage ist leider ein kritischer Fehler aufgetreten. Unser
                                Entwicklerteam
                                wurde benachrichtigt. Wir arbeiten an einer Lösung und danken für Ihre Geduld.</p>

         <p> Dieser Fehler wird unter folgender ID verfolgt: </p>
         <pre>{api.errorCode}</pre>
       </div>
     </Segment>
   </div>
  )
}

const PleaseWait = () => (
  <Dimmer
    active={true}
    page
  >
    <Image className="slide-in" width="75" src={logoSrc} style={{marginTop: "-120px"}} centered/>
    <Loader className="">Auftragsdaten werden geladen</Loader>
  </Dimmer>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js